export const CHATS = "CHATS";
export const UNREAD_CHATS = "UNREAD_CHATS";
export const MESSAGES = "MESSAGES";
